var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInPersonAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.14584C7.72487 7.14584 8.3125 6.55822 8.3125 5.83334C8.3125 5.10847 7.72487 4.52084 7 4.52084C6.27513 4.52084 5.6875 5.10847 5.6875 5.83334C5.6875 6.55822 6.27513 7.14584 7 7.14584Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.246 3.69833C10.6918 2.6425 9.75849 1.87833 8.61515 1.5575C7.81015 1.33 7.17432 1.3125 6.99932 1.3125C6.47432 1.3125 5.95515 1.3825 5.45349 1.5225C4.31599 1.8375 3.37099 2.60167 2.79349 3.68667C2.19265 4.8125 2.08182 6.1425 2.50182 7.39667C3.10849 9.18167 4.12932 10.7683 5.54099 12.1042C5.94932 12.495 6.47432 12.6875 6.99932 12.6875C7.52432 12.6875 8.04932 12.495 8.45765 12.1042C9.86932 10.7625 10.8902 9.18167 11.5085 7.36167C11.9227 6.1425 11.8235 4.8125 11.246 3.70417V3.69833ZM6.99932 8.02083C5.79182 8.02083 4.81182 7.04083 4.81182 5.83333C4.81182 4.62583 5.79182 3.64583 6.99932 3.64583C8.20682 3.64583 9.18682 4.62583 9.18682 5.83333C9.18682 7.04083 8.20682 8.02083 6.99932 8.02083Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPersonAppointment);
export default __webpack_public_path__ + "static/media/in-person-appointment.5cbc1226534574e178dc66c064aba093.svg";
export { ForwardRef as ReactComponent };